import { Suspense, lazy } from 'react';
import { GuestGuard } from "./guards/GuestGuard";
import { LoadingScreen } from './components/loading-screen';
import AuthGuard from "./guards/AuthGuard";
import { DashboardLayout } from './containers/dashboard-layout';
import { Navigate } from "react-router-dom";
import ForgotPassword from './components/login/forgot-password';


//  Dashboard Menu's
import Employees from './project-portal/pages/DashboardMenus/employees';
import ChooseProject from './pages/afterLogin/chooseProject';
import ProjectGuard from './guards/ProjectGuard';
import { ProjectIdContext } from './contexts/Project/Project';
import ProjectSelectGuard from './guards/ProjectURLGuard';
import Pages from './project-portal/pages/DashboardMenus/employees';
import Images from './project-portal/pages/DashboardMenus/Images';
import Directories from './project-portal/pages/DashboardMenus/Directories';
import Errors from './project-portal/pages/DashboardMenus/Errors';

const Loadable = (Component) => (props) => (
    <Suspense fallback={<LoadingScreen />}>
        <Component {...props} />
    </Suspense>
);



// Not found pages
const NotFound = Loadable(lazy(() => import('./containers/not-found').then((module) => ({ default: module.NotFound }))));

// Auth pages
const Login = Loadable(lazy(() => import('./containers/login').then((module) => ({ default: module.Login }))));


const routes = [
    {
        path: '',
        element: (
            <GuestGuard>
                <Login />
            </GuestGuard>
        )
    },
    {
        path: 'forgot-password',
        element: (
            <GuestGuard>
                <ForgotPassword />
            </GuestGuard>
        )
    },
    {
        path: 'select-project',
        element: (
            <AuthGuard>
                    <ChooseProject />
            </AuthGuard>
        ),
    },
    {
        path: 'dashboard',
        element: (
            <AuthGuard>
                <ProjectGuard>
                    <DashboardLayout />
                </ProjectGuard>
            </AuthGuard>
        ),
        children: [
            {
                path: '',
                element: (
                    <Navigate
                        to="/dashboard/pages"
                        replace
                    />
                )
            },

            {
                path: 'pages',
                element: <Pages />
            },
            {
                path: 'images',
                element: <Images />
            },
            {
                path: 'directories',
                element: <Directories />
            },
            {
                path: 'errors',
                element: <Errors />
            },

            // {
            //     path: 'documentcategory',
            //     element: <DocumentCategory />
            // },
            // {
            //     path: 'holidaycalendar',
            //     element: <HolidayCalendar />
            // },

        ],

    },
    {
        path: '*',
        element: <NotFound />
    }


];

export default routes;
